/* Firebase passwordless "magic link" (email-link) sign-in helpers.
 *
 * Flow: sendMagicLink() emails a sign-in link and stashes the email + context
 * in localStorage. The link opens /auth/email-link in a fresh page (possibly a
 * new tab/device), which reads the context and calls completeMagicLink().
 *
 * Requires the Firebase "Email link (passwordless sign-in)" provider to be
 * enabled, and the sending domain to be in Firebase Auth → Authorized domains.
 */
import { auth } from '~/services/firebase'

const EMAIL_KEY = 'ps_email_link_email'
const CTX_KEY = 'ps_email_link_ctx'

// Where the emailed link returns to complete sign-in.
export function emailLinkReturnUrl() {
  return `${window.location.origin}/auth/email-link`
}

export function sendMagicLink(email, ctx = {}) {
  const actionCodeSettings = {
    url: emailLinkReturnUrl(),
    handleCodeInApp: true,
  }
  return auth.sendSignInLinkToEmail(email, actionCodeSettings).then(() => {
    window.localStorage.setItem(EMAIL_KEY, email)
    window.localStorage.setItem(CTX_KEY, JSON.stringify(ctx))
  })
}

export function isMagicLink(href) {
  return auth.isSignInWithEmailLink(href || window.location.href)
}

export function getStoredEmail() {
  return window.localStorage.getItem(EMAIL_KEY) || ''
}

export function getStoredCtx() {
  try {
    return JSON.parse(window.localStorage.getItem(CTX_KEY) || '{}')
  } catch (e) {
    return {}
  }
}

export function completeMagicLink(email, href) {
  return auth.signInWithEmailLink(email, href || window.location.href)
}

export function clearMagicLink() {
  window.localStorage.removeItem(EMAIL_KEY)
  window.localStorage.removeItem(CTX_KEY)
}
